module.exports = {"locales":{"de":"Deutsch","en":"English"}}